import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "./SmoothScroll";
import { CONTACT } from "../data";

export default function Footer() {
  return (
    <footer
      data-testid="main-footer"
      className="bg-obsidian pt-24 lg:pt-32 pb-10"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="border-b border-border pb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-acid mb-6">
            Ready when you are
          </p>
          <button
            data-testid="footer-cta"
            onClick={() => scrollToId("quote")}
            className="group font-display uppercase tracking-tighter text-white text-[18vw] lg:text-[13vw] leading-[0.8] flex items-center gap-4 hover:text-acid transition-colors"
          >
            Ready?
            <ArrowUpRight
              className="text-acid group-hover:rotate-45 transition-transform duration-500"
              size={80}
            />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 py-16">
          <div>
            <div className="font-display uppercase text-lg text-white flex items-center gap-2">
              <span className="w-2.5 h-2.5 bg-acid" />
              Pure Space
            </div>
            <p className="mt-4 text-sm text-zinc-500 font-light max-w-xs">
              Premium commercial & industrial cleaning across South East
              Queensland.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">
              Contact
            </div>
            <a
              href={CONTACT.phoneHref}
              className="block text-white hover:text-acid transition-colors mb-2"
            >
              {CONTACT.phone}
            </a>
            <a
              href={CONTACT.emailHref}
              className="block text-white hover:text-acid transition-colors break-all"
            >
              {CONTACT.email}
            </a>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">
              Coverage
            </div>
            {CONTACT.regions.map((r) => (
              <span key={r} className="block text-zinc-400 text-sm">
                {r}
              </span>
            ))}
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">
              Navigate
            </div>
            {["services", "process", "gallery", "quote"].map((id) => (
              <button
                key={id}
                onClick={() => scrollToId(id)}
                className="block text-zinc-400 text-sm hover:text-acid transition-colors capitalize"
              >
                {id}
              </button>
            ))}
          </div>
        </div>

        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.15em] text-zinc-600">
          <span>© {new Date().getFullYear()} Pure Space Cleaning</span>
          <span>Fully insured · Police-checked crews · Eco-certified</span>
        </div>
      </div>
    </footer>
  );
}
